import React from 'react';

import { VerificationRequestForReportItemFragment } from 'src/api';
import { HiddenResultsTable } from 'src/components/common';
import { useFilterStorage, useSearch } from 'src/hooks/common';
import {
  useReportItemsFilter,
  useVerificationRequestsReportList,
  useVerificationRequestsTableRowActions,
} from 'src/hooks/reports';

import { VERIFICATION_REQUESTS_TABLE_COLUMNS_CV_STAFF } from '../constants';

export const VerificationRequestsTableCVManager: React.FC = () => {
  const { searchValue } = useSearch();
  const { filter } = useReportItemsFilter();
  const { pagination } = useFilterStorage();
  const rowActions = useVerificationRequestsTableRowActions();

  const { verificationRequestsCount, verificationRequests, loading } =
    useVerificationRequestsReportList(filter, !searchValue);

  return (
    <HiddenResultsTable<VerificationRequestForReportItemFragment>
      columns={VERIFICATION_REQUESTS_TABLE_COLUMNS_CV_STAFF}
      rowActions={rowActions}
      items={verificationRequests}
      itemsCount={verificationRequestsCount}
      pagination={pagination}
      loading={loading}
    />
  );
};
